import React from "react";
import { useAppSelector } from "src/hooks/useRedux";
import { DIGITAL_AGENT_BUTTONS, URL_SOURCE_TYPE } from "src/utils/enums";
import { sentPostMessage } from "src/utils/utils";
import { UIButton } from "../uIKit";
import { useIsDigitalOrDigitalAgent } from "src/hooks/useIsDigitalOrDigitalAgent";

interface BackToBenefitsButtonProps {
  style: string;
}

const BackToBenefitsButton: React.FC<BackToBenefitsButtonProps> = ({
  style,
}) => {
  const { strings, hostUrl } = useAppSelector((state) => state.app);
  const isDigitalOrAgent = useIsDigitalOrDigitalAgent();
  const onSubmit = () => {
    const data = { buttonClicked: DIGITAL_AGENT_BUTTONS.BACK_TO_BENEFITS };
    sentPostMessage(data);
  };

  const onSubmitBackToPrevScreen = () => {
    // back to prev screen
    window.history.back();
  };

  return (
    <>
      {isDigitalOrAgent ? (
        <div className="backToBenefitsWrapper">
          <UIButton
            ariaLabel={strings.acc_t_backToBenefits}
            title={strings.t_backToBenefits}
            onSubmit={onSubmit}
            style={style}
          />
        </div>
      ) : (
        <div className="backToBenefitsWrapper">
          <UIButton
            ariaLabel={strings.acc_t_backToBenefits}
            title={strings.t_back_button_benefits}
            onSubmit={onSubmitBackToPrevScreen}
            style={style}
          />
        </div>
      )}
    </>
  );
};

export default BackToBenefitsButton;
